import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { postData } from "../../api/apiMethod";
import "../../assets/css/style.scss";
import hide_text from "../../assets/images/visibility_off.svg";
import RunnBackground from "../../assets/svg/login/backgroundRunn.svg";
import lock_outline from "../../assets/svg/login/passwordIcon.svg";
import playstationLogo from "../../assets/svg/Playstudio_logo.svg";
import LoginHeader from "../../component/Login-header";
import { ResetPassword_URL } from "../../service/API_URL";
import "../Login/login.scss";

function ResetPassword() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [newPasswordError, setNewPasswordError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const [storeFrontAccess, setStoreFrontAccess] = useState("");
  const navigate = useNavigate();
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleMouseDown = (type) => {
    if (type === "new") setShowNewPassword(true);
    else if (type === "confirm") setShowPassword(true);
  };
  const handleMouseUp = (type) => {
    if (type === "new") setShowNewPassword(false);
    else if (type === "confirm") setShowPassword(false);
  };

  const handlePasswordChange = (event) => {
    const newPassword = event.target.value;
    setPassword(newPassword);
    validatePassword(newPassword, confirmPassword);
  };

  const handleConfirmPasswordChange = (event) => {
    const newConfirmPassword = event.target.value;
    setConfirmPassword(newConfirmPassword);
    validatePassword(password, newConfirmPassword);
  };

  const validatePassword = (newPassword, newConfirmPassword) => {
    const passwordRegex =
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;
    if (!passwordRegex.test(newPassword)) {
      setNewPasswordError(
        "Password must contain a minimum of 8 characters and at least one symbol e.g. @, !"
      );
    } else if (newPassword !== newConfirmPassword) {
      setNewPasswordError("");
      setPasswordError("The passwords did not match. Please try again");
    } else {
      setNewPasswordError("");
      setPasswordError("");
    }
  };

  const accessStore = () => {
    const tenantLocalData = localStorage.getItem("tenantInfo");
    if (tenantLocalData) {
      const tenantLocalDataParse = JSON.parse(tenantLocalData);
      setStoreFrontAccess(tenantLocalDataParse?.superTenant);
    }
  };

  const ResetPasswordAPI = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    const email = urlParams.get("email");

    if (!token || !email) {
      alert("Token or email is missing in the reset link");
      return;
    }

    const data = {
      email,
      password,
      confirmPassword,
      token,
    };

    try {
      const response = await postData(ResetPassword_URL, data, {
        "Content-Type": "application/json",
      });

      if (response?.data?.success) {
        alert("Password reset successfully");
        navigate("/login");
      } else {
        alert(response?.data?.message || "Failed to reset password");
      }
    } catch (error) {
      console.error("Error resetting password:", error);
      alert("Error: Link expired or invalid. Please try again.");
    }
  };

  const isSubmitDisabled =
    (passwordError !== "" && newPasswordError !== "") ||
    !password ||
    !confirmPassword;

  useEffect(() => {
    accessStore();
  }, []);

  return (
    <>
      <div className="loginPage">
        <LoginHeader />
        <div className="main">
          <>
            <img
              src={RunnBackground}
              alt="Background"
              className="bottom-background"
            />
            <div className="login-block">
              <div className="login-form">
                <div className="title">
                  <div
                    className="logo"
                    style={{
                      // backgroundImage: `url(${
                      //   storeFrontAccess?.darkThemeLogoImagePath
                      //     ? image_url + storeFrontAccess?.darkThemeLogoImagePath
                      //     : logo
                      // })`,
                      backgroundImage: `url(${playstationLogo})`,
                    }}
                  />
                </div>
                <div className="forgetBlock" style={{ marginBottom: "20px" }}>
                  <div className="forget-title">Reset password</div>
                </div>

                <div className="form-group">
                  <label className="form-label ">New Password</label>
                  <div className="input-group input-group-sm">
                    <div className="input-group-prepend">
                      <img src={lock_outline} alt="" />
                    </div>
                    <input
                      // type="password"
                      type={showNewPassword ? "text" : "password"}
                      placeholder="Minimum 8 characters"
                      className="form-control"
                      value={password}
                      onChange={handlePasswordChange}
                      autoComplete="off"
                    />
                    <div
                      className="input-group-append"
                      style={{
                        cursor: "pointer",
                        zIndex: "99",
                      }}
                      onMouseDown={() => {
                        handleMouseDown("new");
                      }}
                      onMouseUp={() => {
                        handleMouseUp("new");
                      }}
                      onMouseLeave={() => setShowNewPassword(false)}
                    >
                      <img src={hide_text} alt="Hide Text" />
                    </div>
                  </div>
                  {newPasswordError && (
                    <span className="error">{newPasswordError}</span>
                  )}
                </div>

                <div className="form-group">
                  <label className="form-label">Confirm new password</label>
                  <div className="input-group input-group-sm">
                    <div className="input-group-prepend">
                      <img src={lock_outline} alt="" />
                    </div>
                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder="Confirm new password"
                      className="form-control"
                      value={confirmPassword}
                      onChange={handleConfirmPasswordChange}
                      autoComplete="off"
                    />
                    <div
                      className="input-group-append"
                      style={{
                        cursor: "pointer",
                        zIndex: "99",
                      }}
                      onMouseDown={() => {
                        handleMouseDown("confirm");
                      }}
                      onMouseUp={() => {
                        handleMouseUp("confirm");
                      }}
                      onMouseLeave={() => setShowPassword(false)}
                    >
                      <img src={hide_text} alt="Hide Text" />
                    </div>
                  </div>
                  {passwordError && (
                    <span className="error">{passwordError}</span>
                  )}
                </div>

                <button
                  disabled={isSubmitDisabled}
                  onClick={ResetPasswordAPI}
                  className={`forget-btn ${isSubmitDisabled ? "disabled" : ""}`}
                >
                  Reset password
                </button>

                <div className="return-block">
                  Return to{" "}
                  <Link to="/login" className="loginLink">
                    Login!
                  </Link>
                </div>
              </div>
            </div>
          </>
        </div>
      </div>
    </>
  );
}

export default ResetPassword;
